var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReduccionRecursoFosil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 41,
    viewBox: "0 0 37 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-reduccion-recurso-fosil"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reduccion-recurso-fosil",
    clipPath: "url(#clip-reduccion-recurso-fosil)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1056",
    "data-name": "Grupo 1056",
    transform: "translate(23030 2523.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1054",
    "data-name": "Grupo 1054",
    transform: "translate(-23028 -2522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_946",
    "data-name": "Trazado 946",
    d: "M67.021,56.961c1.722,0,3.02-.779,3.02-1.813s-1.3-1.812-3.02-1.812S64,54.115,64,55.148,65.3,56.961,67.021,56.961Zm0-2.416c1.169,0,1.812.454,1.812.6s-.643.6-1.812.6-1.813-.454-1.813-.6S65.851,54.544,67.021,54.544Zm0,0",
    transform: "translate(-58.941 -49.315)",
    fill: "#225B2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_949",
    "data-name": "Trazado 949",
    d: "M0,5.174V1.965C0,.621.286,3.7,10.14,3.7S20.28.621,20.28,1.965V5.174c0,1.344-4.54,2.433-10.14,2.433S0,6.518,0,5.174Z",
    transform: "translate(3.245 26.462)",
    fill: "#43A7B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_83",
    "data-name": "Uni\\xF3n 83",
    d: "M2.2,35.2C.306,34.152,0,33.1,0,33.085V4.626c0-.012.1-1.164,1.85-2.3A12.79,12.79,0,0,1,5.982.734,37.166,37.166,0,0,1,13.871,0h.105C21.69,0,24.769,1.651,25.993,3.038a2.76,2.76,0,0,1,.815,1.974L26.762,24.8V32.5a2.722,2.722,0,0,1-.847,1.874c-1.23,1.339-4.271,2.936-11.762,2.936C10.442,37.305,5.355,36.939,2.2,35.2Zm-.095-3c0,.006.218.695,1.762,1.379,1.421.628,4.289,1.378,9.882,1.378,6.676,0,9.252-1.2,10.237-2.2a1.563,1.563,0,0,0,.534-.99V25.835c-1.442,1.02-4.565,2.385-10.954,2.385-6.919,0-10.124-1.6-11.469-2.632Zm11.461-5.6c6.5,0,9.553-1.293,10.954-2.314V16.912c-1.442,1.02-4.565,2.384-10.954,2.384-6.938,0-10.141-1.611-11.48-2.64l.009,7.451C3.5,25.149,6.7,26.591,13.562,26.591Zm0-8.923c6.5,0,9.553-1.293,10.954-2.314V8.178c-1.442,1.02-4.565,2.385-10.954,2.385-6.957,0-10.159-1.62-11.491-2.649l.009,7.263C3.488,16.218,6.683,17.669,13.562,17.669Zm0-8.734c6.5,0,9.553-1.293,10.954-2.314V5.159c0-.007-.221-.728-1.675-1.444-1.337-.659-4.024-1.444-9.224-1.444s-8.062.785-9.549,1.444a4.135,4.135,0,0,0-2,1.444l0,1.276C3.472,7.476,6.666,8.934,13.562,8.934Z",
    fill: "#225B2A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1055",
    "data-name": "Grupo 1055",
    transform: "translate(-23010.965 -2517.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_788",
    "data-name": "Grupo 788",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_171",
    "data-name": "Elipse 171",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(-0.035 0.016)",
    fill: "#43A7B6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic_trending_up_24px",
    d: "M42.727,13.978l1.827-1.827L40.661,8.258l-3.191,3.191-3.5-3.521L35.1,6.8l2.372,2.389L40.661,6l5.026,5.018,1.827-1.827v4.787Z",
    transform: "translate(-32.604 -1.396)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduccionRecursoFosil);
export default __webpack_public_path__ + "static/media/reduccion-recurso-fosil.a7c9c2c2df2742515c03a9b569477b32.svg";
export { ForwardRef as ReactComponent };